<template>
  <div>
    <Header />
    <div class="hola">
      <Contents />
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "../../components/private/Header";
import Contents from "./components/Contents.vue";
import Footer from "../../components/layout/Footer.vue";

export default {
  components: {
    Header,
    Contents,
    Footer,
  },
};
</script>

<style scoped>
.hola {
  margin-bottom: 26px;
}
</style>
